import { useEffect, useState } from 'react';
import { Card, Table, Input, Select, Button, Progress, Tabs, Badge, Space, Row, Col, Spin, InputNumber } from 'antd';
import {
    SearchOutlined,
    PlusOutlined,
    FileTextOutlined,
    RiseOutlined,
    InboxOutlined,
    BankOutlined,
    RightOutlined
} from '@ant-design/icons';
import axiosInstance from '../../../../variables/api/axiosInstance';
import { LOGGED_USER } from '../../../../variables/constants';
import SDIModal from '../../../../components/ui/SDIModal';
import { displayNumbers } from '../../../../variables/numbersFunctions';
import { useNavigate } from 'react-router-dom';
import { frenchDate } from '../../../../variables/functions';
import { toast } from 'react-toastify';

const Overview = () => {
    const [activeTab, setActiveTab] = useState('gestion');
    const [poolAttestationModal, setPoolAttestationModal] = useState(false);
    const [affectationModalOpen, setAffectationModalOpen] = useState(false);
    const [dispatchModalOpen, setDispatchModalOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [firstAttestation, setFirstAttestation] = useState(0);
    const [lastAttestation, setLastAttestation] = useState(0);
    const [nombre, setNombre] = useState(0);
    const [selectedTypeAttestation, setSelectedTypeAttestation] = useState("");
    const [selectedSerieAttestation, setSelectedSerieAttestation] = useState("");
    const [selectedAgence, setSelectedAgence] = useState("");
    const [datas, setDatas] = useState([]);
    const [poolSubdivisions, setPoolSubdivisions] = useState([]);
    const [lotsData, setLotsData] = useState([]);
    const [typeAttestations, setTypeAttestations] = useState([]);
    const [serieAttestations, setSerieAttestations] = useState(["A", "B", "C", "D"]);
    const [agences, setAgences] = useState([]);
    const [reload, setReload] = useState(false);
    const [loading, setLoading] = useState(true);
    const [lotAttestation, setLotAttestation] = useState({});
    const [paLoading, setPaLoading] = useState(false); //Loading pour le modal d'affectation des attestations du Pool


    const navigate = useNavigate();

    const isCourtier = LOGGED_USER?.agence?.typeAgence === 'COURTIER';

    useEffect(() => {
        axiosInstance
            .get(`/api/lot-attestation/all`)
            .then((res) => {
                console.log(res.data);
                setDatas(res.data);
                isCourtier && setLoading(false);
            })
            .catch((err) => {
                console.log(err);
            });

        if (!isCourtier) {
            axiosInstance
                .get(`/api/dispatched-lot-attestation/stats/all-pool-subdivisions`)
                .then((res) => {
                    // console.log("PoolSubdivisions", res.data);
                    setPoolSubdivisions(res.data);
                    let agencies = res.data?.flatMap((item) => item.agence || []);
                    setAgences(agencies);
                    agencies && setSelectedAgence(agencies[0].codeAgence);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                });

            axiosInstance
                .get(`/api/agence/dtrf`)
                .then((res) => {
                    setAgences(res.data);
                    res?.data && setSelectedAgence(res?.data[0].codeAgence);
                    setLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                });
        }

        axiosInstance
            .get(`/api/lot-attestation/compagnie-stats/${LOGGED_USER?.profil?.organisme?.code}`)
            .then((res) => {
                console.log("Lots Data", res.data);
                setLotsData(res?.data?.reverse().map((lo, index) => ({
                    key: index,
                    lot: `${lo.start}-${lo.end}`,
                    total: lo?.lot,
                    serie: lo?.serie,
                    nbreRestant: lo?.updatedLot ? lo?.updatedLot : 0,
                    nbreEndommages: lo?.damagedLot ? lo?.damagedLot : 0,
                    date: lo.dateReception,
                    percentage: (100 * ((lo.lot) - (lo.updatedLot + lo.damagedLot + lo.canceledLot)) / (lo.lot)).toFixed(2),
                    data: lo,
                })));
                setReload(false);
            })
            .catch((err) => {
                console.log(err);
            });

        axiosInstance
            .get(`/api/produit-attestation`)
            .then((res) => {
                // console.log(res.data);
                setTypeAttestations(res.data);
            })
            .catch((err) => {
                console.log(err);
            });
    }, [reload, isCourtier]);


    const getProgressColor = (percentage) => {
        const pct = parseFloat(percentage);
        if (pct < 30) return '#52c41a';
        if (pct < 60) return '#1890ff';
        if (pct < 80) return '#faad14';
        return '#ff4d4f';
    };

    const onSubmit = () => {
        setPaLoading(true);
        if (nombre === lastAttestation - firstAttestation + 1) {
            const catg = typeAttestations.find(element => element.codeId === selectedTypeAttestation);
            if (!catg) return toast("Veuillez choisir un type d'attestation");
            let lot = {
                compagnie: LOGGED_USER?.profil?.organisme,
                lot: [firstAttestation, lastAttestation],
                updatedLot: [firstAttestation, lastAttestation],
                typeAttestation: catg,
                serie: selectedSerieAttestation
            }
            // console.log("Loooot: ", lot, catg);
            axiosInstance
                .post(`/api/lot-attestation`, JSON.stringify(lot))
                .then((res) => {
                    console.log("Data Ressst", res);
                    if (res.status === 226) {
                        toast("Ce numéro d'attestation existe déjà!");
                    } else {
                        setAffectationModalOpen(false);
                        setReload(true);
                        toast("Lot d'attestation ajoutée avec succès");
                    }
                    setPaLoading(false);
                })
                .catch((err) => {
                    console.log(err);
                    if (err.response.status === 226) {
                        toast("Ce numéro d'attestation existe déjà!");
                    } else {
                        toast("Erreur lors de l'ajout du lot d'attestation");
                    }
                    setPaLoading(false);
                });
        } else {
            setPaLoading(false);
            toast("Veuillez vérifier les valeurs que vous avez saisi!");
        }
    }

    const onSubmitDispatch = () => {
        setPaLoading(true);
        if (nombre === lastAttestation - firstAttestation + 1) {
            let allWantedAttestations = Array.from({ length: nombre }, (_, i) => firstAttestation + i);

            let presentElement = allWantedAttestations.some(element => lotAttestation.start <= element && element <= lotAttestation.end);
            if (presentElement) {

                axiosInstance
                    .get(`/api/dispatched-lot-attestation/lot/${lotAttestation.codeId}/${firstAttestation}/${lastAttestation}/${selectedAgence}`)
                    .then((res) => {
                        console.log("Data Ressst", res);
                        if (res.status === 226) {
                            toast("Ce numéro d'attestation existe déjà!");
                        } else {
                            setDispatchModalOpen(false);
                            setReload(true);
                            toast("Lot d'attestation ajoutée avec succès");
                        }
                        setPaLoading(false);
                    })
                    .catch((err) => {
                        console.log(err);
                        if (err.response.status === 226) {
                            toast("Ce numéro d'attestation existe déjà!");
                        } else {
                            toast("Erreur lors de l'ajout du lot d'attestation");
                        }
                        setPaLoading(false);
                    });
            } else {
                setPaLoading(false);
                toast("Il existe des attestations déjà dispatchées ou utilisées dans votre sélection");
            }
        } else {
            setPaLoading(false);
            toast("Veuillez vérifier les valeurs que vous avez saisi!");
        }
    }

    const StatCard = ({ title, value, icon, bgColor, trend }) => (
        <Card
            bordered={false}
            style={{
                borderRadius: '16px',
                boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                background: '#fff',
                height: '100%'
            }}
        >
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                    <div style={{ color: '#8c8c8c', fontSize: '14px', marginBottom: '8px' }}>{title}</div>
                    <div style={{ fontSize: '28px', fontWeight: 'bold', color: '#262626', marginBottom: '4px' }}>
                        {value}
                    </div>
                    {trend && (
                        <div style={{ color: '#52c41a', fontSize: '13px', display: 'flex', alignItems: 'center', gap: '4px' }}>
                            <RiseOutlined />
                            {trend}
                        </div>
                    )}
                </div>
                <div style={{
                    width: '56px',
                    height: '56px',
                    borderRadius: '12px',
                    background: bgColor,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    fontSize: '24px',
                    color: '#fff'
                }}>
                    {icon}
                </div>
            </div>
        </Card>
    );

    const CompanyCard = ({ data }) => {
        const percentage = data.total ? (100 * data.used / data.total) : 0;
        return (
            <Card
                bordered={false}
                hoverable
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    transition: 'all 0.3s',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            background: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: '20px'
                        }}>
                            <BankOutlined />
                        </div>
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '16px', color: '#262626' }}>
                                {data.compagnie}
                            </div>
                            <div style={{ fontSize: '13px', color: '#8c8c8c' }}>
                                {data.used} / {data.total} utilisées
                            </div>
                        </div>
                    </div>
                    <Button
                        type="button"
                        shape="circle"
                        icon={<RightOutlined />}
                        style={{
                            background: '#f5f5f5',
                            border: 'none'
                        }}
                        onClick={() => navigate(`/lots-attestations/${data.code}`)}
                    />
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <span style={{ fontSize: '13px', color: '#8c8c8c' }}>Progression</span>
                        <span style={{ fontWeight: '600', color: '#262626' }}>{percentage.toFixed(1)}%</span>
                    </div>
                    <Progress
                        percent={percentage}
                        strokeColor={getProgressColor(percentage)}
                        showInfo={false}
                        strokeWidth={8}
                    />
                </div>
            </Card>
        );
    };

    const SubdivisionCard = ({ data }) => {
        const percentage = data.total ? (100 * data.used / data.total) : 0;
        return (
            <Card
                bordered={false}
                hoverable
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
                    transition: 'all 0.3s',
                }}
            >
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                        <div style={{
                            width: '48px',
                            height: '48px',
                            borderRadius: '12px',
                            background: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            color: '#fff',
                            fontSize: '20px'
                        }}>
                            <BankOutlined />
                        </div>
                        <div>
                            <div style={{ fontWeight: '600', fontSize: '16px', color: '#262626' }}>
                                {data.compagnie}
                            </div>
                            <div style={{ fontSize: '13px', color: '#8c8c8c' }}>
                                {data.used} / {data.total} utilisées
                            </div>
                        </div>
                    </div>
                    <Button
                        type="text"
                        shape="circle"
                        icon={<RightOutlined />}
                        style={{
                            background: '#f5f5f5',
                            border: 'none'
                        }}
                        onClick={() => navigate(`/dispatched-lots-attestations/${data.code}`, { state: { codeAgence: data.code, codeOrganisme: "00" } })}
                    />
                </div>
                <div>
                    <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '8px' }}>
                        <span style={{ fontSize: '13px', color: '#8c8c8c' }}>Progression</span>
                        <span style={{ fontWeight: '600', color: '#262626' }}>{percentage.toFixed(1)}%</span>
                    </div>
                    <Progress
                        percent={percentage}
                        strokeColor={getProgressColor(percentage)}
                        showInfo={false}
                        strokeWidth={8}
                    />
                </div>
            </Card>
        );
    };

    const poolAttestationsColumns = [
        {
            title: 'Lot',
            dataIndex: 'lot',
            key: 'lot',
            render: (text, record) => <span style={{ fontWeight: '600' }}>{text} ({record?.serie})</span>
        },
        {
            title: 'Total',
            dataIndex: 'total',
            key: 'total',
        },
        {
            title: 'Restant',
            dataIndex: 'nbreRestant',
            key: 'nbreRestant',
            render: (text) => <div class="badge bg-label-success">{displayNumbers(text)}</div>
        },
        {
            title: 'Endommagés',
            dataIndex: 'nbreEndommages',
            key: 'nbreEndommages',
            render: (text) => <div class="badge bg-label-danger">{displayNumbers(text)}</div>
        },
        {
            title: 'Pourcentage',
            dataIndex: 'percentage',
            key: 'percentage',
            render: (_, record) => (
                <div class="badge bg-label-primary">{record?.percentage}%</div>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (_, record) => (
                record.date ? (
                    <Badge status="success" text={`Livré le ${frenchDate(record.date)}`} />
                ) : record?.percentage < 100 ? (
                    <Button
                        type="primary"
                        size="small"
                        style={{
                            background: '#faad14',
                            borderColor: '#faad14'
                        }}
                        onClick={() => {
                            setLotAttestation(record.data);
                            setDispatchModalOpen(true);
                        }}
                    >
                        Dispatcher
                    </Button>
                ) : "En attente de livraison"
            )
        }
    ];

    const tabItems = [
        {
            key: 'gestion',
            label: 'Gestion des Compagnies',
            children: (
                <Row gutter={[16, 16]}>
                    {datas.map((data, id) => (
                        <Col xs={24} sm={12} key={id}>
                            <CompanyCard data={data} />
                        </Col>
                    ))}
                </Row>
            )
        },
        {
            key: 'subdivisions',
            label: 'Autres Subdivisions',
            children: (
                <Row gutter={[16, 16]}>
                    {poolSubdivisions.map((data, id) => (
                        <Col xs={24} sm={12} key={id}>
                            <SubdivisionCard data={data} />
                        </Col>
                    ))}
                </Row>
            )
        }
    ];

    return (
        <div
            style={{
                minHeight: '100vh',
                background: 'linear-gradient(135deg, #f5f7fa 0%, #e8f0fe 50%, #f0ebff 100%)',
                padding: '24px'
            }}
        >
            {/* Header */}
            <div style={{ marginBottom: '22px', marginTop: '-20px' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '14px' }}>
                    <div>
                        <h1 style={{
                            fontSize: '32px',
                            fontWeight: 'bold',
                            color: '#262626',
                            marginBottom: '0px'
                        }}>
                            Gestion des Attestations
                        </h1>
                        <p style={{ color: '#8c8c8c', fontSize: '15px', margin: 0 }}>
                            Vue d'ensemble de la distribution et utilisation des attestations
                        </p>
                    </div>
                    <Button
                        type="primary"
                        icon={<FileTextOutlined />}
                        onClick={() => setPoolAttestationModal(true)}
                        style={{
                            background: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
                            border: 'none',
                            borderRadius: '12px',
                            height: '48px',
                            padding: '0 24px',
                            fontWeight: '600',
                            boxShadow: '0 4px 12px rgba(24, 144, 255, 0.3)'
                        }}
                    >
                        Nos Attestations
                    </Button>
                </div>

                {/* Stats Cards */}
                <Row gutter={[16, 16]}>
                    <Col xs={24} sm={12} lg={6}>
                        <StatCard
                            title="Total Attestations"
                            value={displayNumbers(datas.reduce((sum, d) => sum + d.total, 0) + poolSubdivisions.reduce((sum, d) => sum + d.total, 0))}
                            icon={<FileTextOutlined />}
                            bgColor="linear-gradient(135deg, #1890ff 0%, #096dd9 100%)"
                            trend="+12% ce mois"
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                        <StatCard
                            title="Utilisées"
                            value={displayNumbers(datas.reduce((sum, d) => sum + d.used, 0) + poolSubdivisions.reduce((sum, d) => sum + d.used, 0))}
                            icon={<RiseOutlined />}
                            bgColor="linear-gradient(135deg, #52c41a 0%, #389e0d 100%)"
                            trend="32% du total"
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                        <StatCard
                            title="Disponibles"
                            value={displayNumbers(datas.reduce((sum, d) => sum + d.total, 0) + poolSubdivisions.reduce((sum, d) => sum + d.total, 0) - datas.reduce((sum, d) => sum + d.used, 0) - poolSubdivisions.reduce((sum, d) => sum + d.used, 0))}
                            icon={<InboxOutlined />}
                            bgColor="linear-gradient(135deg, #faad14 0%, #d48806 100%)"
                        />
                    </Col>
                    <Col xs={24} sm={12} lg={6}>
                        <StatCard
                            title="Compagnies"
                            value={datas.length || 0}
                            icon={<BankOutlined />}
                            bgColor="linear-gradient(135deg, #722ed1 0%, #242166 100%)"
                        />
                    </Col>
                </Row>
            </div>

            {/* Main Content */}
            <Card
                bordered={false}
                style={{
                    borderRadius: '16px',
                    boxShadow: '0 2px 16px rgba(0,0,0,0.08)'
                }}
            >
                <Input
                    placeholder="Rechercher une compagnie..."
                    prefix={<SearchOutlined style={{ color: '#8c8c8c' }} />}
                    size="large"
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    style={{
                        marginBottom: '24px',
                        borderRadius: '12px',
                        border: '1px solid #e8e8e8'
                    }}
                />
                <Spin spinning={loading}>
                    <Tabs
                        defaultActiveKey="gestion"
                        items={tabItems}
                        onChange={setActiveTab}
                        size="large"
                    />
                </Spin>

            </Card>

            {/* Modal Attestations du POOL */}
            <SDIModal
                title={
                    <div style={{
                        background: '#242166',
                        margin: '-20px -24px 20px',
                        padding: '24px',
                        color: '#fff'
                    }}>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', marginBottom: '4px' }}>
                            Attestations du POOL
                        </div>
                        <div style={{ fontSize: '14px', opacity: 0.9 }}>
                            POOL TPVM-VT GIE
                        </div>
                    </div>
                }
                open={poolAttestationModal}
                onCancel={() => setPoolAttestationModal(false)}
                width={1200}
                footer={null}
                style={{ top: 20 }}
                zIndex={2000}
            >
                <div style={{ display: 'flex', justifyContent: 'flex-end', marginBottom: '16px' }}>
                    <Button
                        type="primary"
                        icon={<PlusOutlined />}
                        onClick={() => setAffectationModalOpen(true)}
                        style={{
                            background: '#242166',
                            border: 'none',
                            borderRadius: '8px'
                        }}
                    >
                        Affecter un lot
                    </Button>
                </div>
                <Table
                    columns={poolAttestationsColumns}
                    dataSource={lotsData}
                    pagination={{ showSizeChanger: true }}
                    style={{ borderRadius: '8px' }}
                />
            </SDIModal>

            {/* Modal Affectation */}
            <SDIModal
                title={
                    <div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#262626' }}>
                            Nouveau lot d'attestation
                        </div>
                        <div style={{ fontSize: '14px', color: '#8c8c8c', marginTop: '4px' }}>
                            Affecter un nouveau lot pour le POOL TPVM-VT GIE
                        </div>
                    </div>
                }
                open={affectationModalOpen}
                onOk={onSubmit}
                onCancel={() => {
                    setFirstAttestation(0);
                    setLastAttestation(0);
                    setNombre(0);
                    setAffectationModalOpen(false);
                }}
                okText="Confirmer"
                cancelText="Annuler"
                okButtonProps={{
                    style: {
                        background: 'linear-gradient(135deg, #1890ff 0%, #242166 100%)',
                        border: 'none',
                        borderRadius: '8px'
                    }
                }}
                cancelButtonProps={{
                    style: { borderRadius: '8px' }
                }}
                width={600}
                zIndex={2010}
                loading={paLoading}
            >
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Première attestation
                        </label>
                        <InputNumber
                            placeholder="10000"
                            value={firstAttestation || ''}
                            onChange={(e) => {
                                setFirstAttestation(parseInt(e) || 0);
                                setLastAttestation(parseInt(e) || 0);
                            }}
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                            }
                            parser={(value) =>
                                value.replace(/\s/g, "")
                            }
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Nombre d'attestations
                        </label>
                        <InputNumber
                            placeholder="5000"
                            value={nombre || ''}
                            onChange={(e) => setNombre(parseInt(e) || 0)}
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                            }
                            parser={(value) =>
                                value.replace(/\s/g, "")
                            }
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Dernière attestation
                        </label>
                        <InputNumber
                            placeholder="15000"
                            value={lastAttestation || ''}
                            onChange={(e) => setLastAttestation(parseInt(e) || 0)}
                            style={{ borderRadius: '8px', width: '100%' }}
                            min={0}
                            formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                            }
                            parser={(value) =>
                                value.replace(/\s/g, "")
                            }
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Type d'attestation
                        </label>
                        <Select
                            value={selectedTypeAttestation}
                            onChange={setSelectedTypeAttestation}
                            style={{ width: '100%', borderRadius: '8px' }}
                        >
                            {typeAttestations.map((type) => (
                                <Select.Option key={type.codeId} value={type.codeId}>
                                    {type.typeAttestation}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Série d'attestation
                        </label>
                        <Select
                            value={selectedSerieAttestation}
                            onChange={setSelectedSerieAttestation}
                            style={{ width: '100%', borderRadius: '8px' }}
                        >
                            {serieAttestations.map((serie) => (
                                <Select.Option key={serie} value={serie}>
                                    {serie}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </Space>
            </SDIModal>

            {/* Modal Dispatch */}
            <SDIModal
                title={
                    <div>
                        <div style={{ fontSize: '20px', fontWeight: 'bold', color: '#262626' }}>
                            Nouveau Dispatch d'attestation
                        </div>
                        <div style={{ fontSize: '14px', color: '#8c8c8c', marginTop: '4px' }}>
                            Affecter un nouveau lot d'attestation à une subdivision
                        </div>
                    </div>
                }
                open={dispatchModalOpen}
                onOk={onSubmitDispatch}
                onCancel={() => {
                    setFirstAttestation(0);
                    setLastAttestation(0);
                    setNombre(0);
                    setSelectedAgence("");
                    setDispatchModalOpen(false);
                }}
                okText="Dispatcher"
                cancelText="Annuler"
                okButtonProps={{
                    style: {
                        background: '#faad14',
                        border: 'none',
                        borderRadius: '8px'
                    }
                }}
                cancelButtonProps={{
                    style: { borderRadius: '8px' }
                }}
                width={600}
                zIndex={2010}
                loading={paLoading}
            >
                <Space direction="vertical" size="large" style={{ width: '100%' }}>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Agence
                        </label>
                        <Select
                            value={selectedAgence}
                            onChange={setSelectedAgence}
                            placeholder="Sélectionner une agence"
                            style={{ width: '100%', borderRadius: '8px' }}
                        >
                            {agences.map((ag) => (
                                <Select.Option key={ag.codeAgence} value={ag.codeAgence}>
                                    {ag.nom}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Première attestation
                        </label>
                        <InputNumber
                            placeholder="10000"
                            value={firstAttestation || ''}
                            onChange={(e) => {
                                setFirstAttestation(parseInt(e) || 0);
                                setLastAttestation(parseInt(e) || 0);
                            }}
                            style={{ borderRadius: '8px', width: '100%' }}
                            formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                            }
                            parser={(value) =>
                                value.replace(/\s/g, "")
                            }
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Dernière attestation
                        </label>
                        <InputNumber
                            placeholder="15000"
                            value={lastAttestation || ''}
                            onChange={(e) => setLastAttestation(parseInt(e) || 0)}
                            style={{ borderRadius: '8px', width: '100%' }}
                            formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                            }
                            parser={(value) =>
                                value.replace(/\s/g, "")
                            }
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Nombre d'attestations
                        </label>
                        <InputNumber
                            placeholder="5000"
                            value={nombre || ''}
                            onChange={(e) => setNombre(parseInt(e) || 0)}
                            style={{ borderRadius: '8px', width: '100%' }}
                            formatter={(value) =>
                                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, " ")
                            }
                            parser={(value) =>
                                value.replace(/\s/g, "")
                            }
                        />
                    </div>
                    <div>
                        <label style={{ display: 'block', marginBottom: '8px', fontWeight: '600', color: '#262626' }}>
                            Type d'attestation
                        </label>
                        <Select
                            size="large"
                            value={selectedTypeAttestation}
                            onChange={setSelectedTypeAttestation}
                            style={{ width: '100%', borderRadius: '8px' }}
                        >
                            {typeAttestations.map((type) => (
                                <Select.Option key={type.codeId} value={type.codeId}>
                                    {type.typeAttestation}
                                </Select.Option>
                            ))}
                        </Select>
                    </div>
                </Space>
            </SDIModal>
        </div>
    );
};

export default Overview;